import { render, staticRenderFns } from "./FarmVehicleTypeSettings.vue?vue&type=template&id=c30884b8&scoped=true&"
import script from "./FarmVehicleTypeSettings.vue?vue&type=script&lang=ts&"
export * from "./FarmVehicleTypeSettings.vue?vue&type=script&lang=ts&"
import style0 from "./FarmVehicleTypeSettings.vue?vue&type=style&index=0&id=c30884b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30884b8",
  null
  
)

export default component.exports